import { render, staticRenderFns } from "./ReservarCita.vue?vue&type=template&id=2ef5c215&"
import script from "./ReservarCita.vue?vue&type=script&lang=js&"
export * from "./ReservarCita.vue?vue&type=script&lang=js&"
import style0 from "./ReservarCita.vue?vue&type=style&index=0&id=2ef5c215&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports